export function replace(path, processRoute) {
    history.replaceState(undefined, '', path);
    return processRoute();
}
